export default {
  'externel-bucket-info-title': '他社バケット情報',
  'externel-bucket-input-title': '他社バケット入力',
  'externel-bucket-confirm-title': '他社バケット連携確認',
  'label-bucket-name': 'バケット名',
  'externel-bucket-confirm-message': '下記バケット情報と連携処理を行なって良いですか？',
}
